import { CourseVersion } from '@scale/shared/defaults';

export enum OutlineStepType {
  VIDEO = 'Video',
}

export enum OutlineStepStatus {
  NOT_STARTED,
  IN_PROGRESS,
  COMPLETED,
}

export type OutlineStep = {
  title: string;
  timeEstimate: number;
  stepStatus: OutlineStepStatus;
  stepType?: OutlineStepType;
  courseVersion?: CourseVersion;
};
